export function pushNotification(msg) {
  
  if (!("Notification" in window)) return;
  if (Notification.permission !== "granted") return;
  
  console.log("Notification permission:", Notification.permission);

  const notification = new Notification(msg.title || "Notification", {
    body: msg.body || "",
    icon: "/favicon.ico",
  });

  notification.onclick = () => {
    window.focus();

    if (msg.path) {
      window.location.href = msg.path;
    }
  };
}
